import React from "react";
import BootstrapTable from "react-bootstrap-table-next";
import { Link } from "react-router-dom";
import paginationFactory from "react-bootstrap-table2-paginator";
import ToolkitProvider, { Search } from "react-bootstrap-table2-toolkit/dist/react-bootstrap-table2-toolkit";
import { Sparklines, SparklinesLine, SparklinesSpots } from "react-sparklines";
import moment from "moment";
import { connect } from "react-redux";
import { bulkSchakelkwhnmeter, bulkAmpere } from "../../../Sensors/Reducers/actions";

class KampeerplaatsLijst extends React.Component {
  state = {
    errors: {},
    load: false,
    selectedSensors: [],
    bulkAction: false,
    bulkMessage: null,
    selectedAmpere: 16,
    showAmpereDropdown: false,
  };

  handleBulkSchakelen = async (schakelen) => {
    const { selectedSensors } = this.state;
    if (selectedSensors.length === 0) {
      this.setState({ 
        bulkMessage: { 
          type: 'warning', 
          text: 'Selecteer eerst sensoren om een bulk actie uit te voeren' 
        } 
      });
      setTimeout(() => this.setState({ bulkMessage: null }), 5000);
      return;
    }

    this.setState({ bulkAction: true, bulkMessage: null });

    try {
      const result = await this.props.bulkSchakelkwhnmeter(selectedSensors, schakelen);
      
      if (result.status === 'processing') {
        this.setState({ 
          bulkMessage: { 
            type: 'success', 
            text: `${result.message} - De actie wordt op de achtergrond uitgevoerd met 20 seconden vertraging tussen elke sensor.` 
          } 
        });
        setTimeout(() => this.setState({ bulkMessage: null }), 10000);
      }
      
    } catch (error) {
      this.setState({ 
        bulkMessage: { 
          type: 'danger', 
          text: `Er is een fout opgetreden bij de bulk actie: ${error.message}` 
        } 
      });
      setTimeout(() => this.setState({ bulkMessage: null }), 8000);
    }

    this.setState({ bulkAction: false, selectedSensors: [] });
  };

  handleBulkAmpere = async (ampere) => {
    const { selectedSensors } = this.state;
    if (selectedSensors.length === 0) {
      this.setState({ 
        bulkMessage: { 
          type: 'warning', 
          text: 'Selecteer eerst sensoren om een bulk ampere actie uit te voeren' 
        } 
      });
      setTimeout(() => this.setState({ bulkMessage: null }), 5000);
      return;
    }

    this.setState({ bulkAction: true, bulkMessage: null, showAmpereDropdown: false });

    try {
      const result = await this.props.bulkAmpere(selectedSensors, ampere);
      
      if (result.status === 'processing') {
        this.setState({ 
          bulkMessage: { 
            type: 'success', 
            text: `${result.message} - De ampere wordt ingesteld op ${ampere}A met 20 seconden vertraging tussen elke sensor.` 
          } 
        });
        setTimeout(() => this.setState({ bulkMessage: null }), 10000);
      }
      
    } catch (error) {
      this.setState({ 
        bulkMessage: { 
          type: 'danger', 
          text: `Er is een fout opgetreden bij de bulk ampere actie: ${error.message}` 
        } 
      });
      setTimeout(() => this.setState({ bulkMessage: null }), 8000);
    }

    this.setState({ bulkAction: false, selectedSensors: [] });
  };

  handleSelectSensor = (sensorId, checked) => {
    this.setState(prevState => {
      let newSelected;
      if (checked) {
        newSelected = [...prevState.selectedSensors, sensorId];
      } else {
        newSelected = prevState.selectedSensors.filter(id => id !== sensorId);
      }
      return { selectedSensors: newSelected };
    });
  };

  handleSelectAll = (checked) => {
    const { kampeerplaatsen } = this.props;
    if (checked) {
      const allSensorIds = kampeerplaatsen
        .filter(plaats => plaats.sensor && plaats.sensor.device_id)
        .map(plaats => plaats.sensor.device_id);
      this.setState({ selectedSensors: allSensorIds });
    } else {
      this.setState({ selectedSensors: [] });
    }
  };

  render() {
    const { SearchBar } = Search;
    
    // Responsive column configuration
    const getColumns = () => {
      const isMobile = window.innerWidth <= 768;
      const isTablet = window.innerWidth <= 1024 && window.innerWidth > 768;
      
      const baseColumns = [
        {
          dataField: "select",
          text: (
            <input
              type="checkbox"
              onChange={(e) => this.handleSelectAll(e.target.checked)}
              checked={this.state.selectedSensors.length === this.props.kampeerplaatsen.filter(k => k.sensor?.device_id).length && this.props.kampeerplaatsen.filter(k => k.sensor?.device_id).length > 0}
            />
          ),
          formatter: (cellContent, row) => {
            return row.sensor?.device_id ? (
              <input
                type="checkbox"
                checked={row._isSelected || false}
                onChange={(e) => {
                  this.handleSelectSensor(row.sensor.device_id, e.target.checked);
                }}
                disabled={this.state.bulkAction}
              />
            ) : null;
          },
          headerAlign: "left",
          align: "left",
          sort: false,
          headerStyle: { width: "50px", minWidth: "50px" },
        },
        {
          dataField: "naam",
          text: "Stroompunt",
          sort: true,
          searchable: true,
          headerStyle: { minWidth: isMobile ? '120px' : '150px' },
          formatter: (cellContent, row) => {
            return (
              <div className="d-flex flex-column">
                <strong>{cellContent}</strong>
                {isMobile && row?.sensor?.device_id && (
                  <small className="text-muted">ID: {row.sensor.device_id}</small>
                )}
              </div>
            );
          },
        },
        {
          dataField: "sensor.device_id",
          text: "Sensor ID",
          sort: true,
          hidden: isMobile,
          headerStyle: { minWidth: '100px' },
          formatter: (cellContent, row) => {
            return cellContent;
          },
        },
        {
          dataField: "sensor.lastcheck",
          text: "Laatste data",
          sort: true,
          headerStyle: { minWidth: isMobile ? '90px' : '120px' },
          formatter: (cellContent, row) => {
            if (row?.sensor?.lastcheck) {
              return (
                <div className="d-flex flex-column">
                  <span>{moment(row.sensor.lastcheck).fromNow()}</span>
                  {isMobile && (
                    <small className="text-muted">
                      {Number(row?.sensor?.lastvalue).toFixed(2)} kWh
                    </small>
                  )}
                </div>
              );
            }
          },
        },
        {
          dataField: "lastcheck",
          text: "Meterstand",
          hidden: isMobile,
          headerStyle: { minWidth: '100px' },
          formatter: (cellContent, row) => {
            return Number(row?.sensor?.lastvalue).toFixed(2);
          },
        },
        {
          text: "Status",
          dataField: "sensor.electra.ingeschakeld",
          headerAlign: "center",
          sort: true,
          align: "center",
          headerStyle: { width: isMobile ? "50px" : "60px", minWidth: isMobile ? "50px" : "60px" },
          formatter: (cellContent, row) => (
            <div className="d-flex flex-column align-items-center">
              {cellContent ? (
                <>
                  <i className="fas fa-toggle-on text-success" style={{ fontSize: isMobile ? '1.2em' : '1.4em' }}></i>
                  {!isMobile && <small className="text-success fw-bold mt-1">Aan</small>}
                </>
              ) : (
                <>
                  <i className="fas fa-toggle-off text-danger" style={{ fontSize: isMobile ? '1.2em' : '1.4em' }}></i>
                  {!isMobile && <small className="text-danger mt-1">Uit</small>}
                </>
              )}
              {isMobile && row?.sensor?.electra?.ampere && (
                <small className="text-muted mt-1">{row.sensor.electra.ampere}A</small>
              )}
              {isMobile && row?.sensor?.boeking?.gastinfo && (
                <span 
                  className={`badge ${row.sensor.boeking.betaald ? 'badge-success' : 'badge-warning'} badge-sm mt-1`} 
                  style={{ fontSize: '0.6em' }}
                  title={`Geboekt door: ${row.sensor.boeking.gastinfo.achternaam || row.sensor.boeking.gastinfo.voornaam || 'Onbekende gast'}`}
                >
                  {row.sensor.boeking.betaald ? 'Betaald' : 'Geboekt'}
                </span>
              )}
            </div>
          ),
        },
        {
          text: "Ampere",
          dataField: "sensor.electra.ampere",
          headerAlign: "center",
          align: "center",
          hidden: isMobile,
          headerStyle: { width: "60px", minWidth: "60px" },
          formatter: (cellContent, row) => <div className="ampereicon">{cellContent}A</div>,
        },
        {
          text: "Boeking",
          dataField: "sensor.boeking",
          headerAlign: "center",
          align: "center",
          sort: true,
          hidden: isMobile,
          headerStyle: { minWidth: '120px' },
          formatter: (cellContent, row) => {
            const boeking = row?.sensor?.boeking;
            const gastinfo = boeking?.gastinfo;
            
            if (!boeking || !gastinfo) {
              return <span className="badge badge-secondary">Geen boeking</span>;
            }

            const gastNaam = gastinfo.achternaam || gastinfo.voornaam || 'Onbekende gast';
            const isPaid = boeking.betaald;
            
            if (isPaid) {
              return (
                <span 
                  className="badge badge-success" 
                  title={`Geboekt door: ${gastNaam}`}
                  style={{ cursor: 'help' }}
                >
                  Geboekt & Betaald
                </span>
              );
            } else {
              return (
                <span 
                  className="badge badge-warning" 
                  title={`Geboekt door: ${gastNaam}`}
                  style={{ cursor: 'help' }}
                >
                  Geboekt - Niet betaald
                </span>
              );
            }
          },
          sortValue: (cell, row) => {
            const boeking = row?.sensor?.boeking;
            if (!boeking || !boeking.gastinfo) return 0;
            const isPaid = boeking.betaald;
            return isPaid ? 3 : 2; // Betaald = 3, Niet betaald = 2, Geen boeking = 0
          },
        },
        {
          text: "Acties",
          dataField: "soort",
          headerAlign: "center",
          align: "center",
          headerStyle: { minWidth: isMobile ? '80px' : '200px' },
          formatter: (cellContent, row) => {
            if (isMobile) {
              return (
                <div className="btn-group-vertical" role="group">
                  <Link 
                    className="btn btn-sm btn-warning btn-sm mb-1" 
                    to={{ pathname: "/standplaatsen/kampeerplaatsen/edit/" + row._id }}
                  >
                    Wijzigen
                  </Link>
                  <Link 
                    className="btn btn-sm btn-success btn-sm" 
                    to={{ pathname: "/standplaatsen/kampeerplaatsen/show/" + row._id }}
                  >
                    Bekijken
                  </Link>
                </div>
              );
            }
            
            return (
              <div className={isTablet ? "btn-group-vertical" : "btn-group"} role="group">
                <Link 
                  className={`btn btn-sm btn-warning ${isTablet ? 'btn-sm mb-1' : 'mx-1'}`}
                  to={{ pathname: "/standplaatsen/kampeerplaatsen/edit/" + row._id }}
                >
                  Wijzigen
                </Link>
                <Link 
                  className={`btn btn-sm btn-success ${isTablet ? 'btn-sm' : ''}`}
                  to={{ pathname: "/standplaatsen/kampeerplaatsen/show/" + row._id }}
                >
                  Bekijken
                </Link>
              </div>
            );
          },
        },
      ];
      
      return baseColumns;
    };
    
    const columns = getColumns();
    const { kampeerplaatsen } = this.props;
    const { selectedSensors, bulkAction, bulkMessage, selectedAmpere, showAmpereDropdown } = this.state;
    
    // Add selection state to each row data to force formatter updates
    const dataWithSelections = kampeerplaatsen.map(item => ({
      ...item,
      _isSelected: selectedSensors.includes(item.sensor?.device_id)
    }));
    
    return (
      <>
        {/* Bulk Actions */}
        <div className="card mb-3">
          <div className="card-body">
            <div className="d-flex justify-content-between align-items-center">
              <div className="d-flex align-items-center gap-3">
                <div className="form-check">
                  <input
                    className="form-check-input"
                    type="checkbox"
                    id="selectAllTable"
                    checked={selectedSensors.length === kampeerplaatsen.filter(k => k.sensor?.device_id).length && kampeerplaatsen.filter(k => k.sensor?.device_id).length > 0}
                    onChange={(e) => this.handleSelectAll(e.target.checked)}
                    disabled={bulkAction}
                  />
                  <label className="form-check-label" htmlFor="selectAllTable">
                    Selecteer alle sensoren
                  </label>
                </div>
                {selectedSensors.length > 0 && (
                  <span className="badge badge-info">{selectedSensors.length} geselecteerd</span>
                )}
              </div>
              
              <div className="d-flex gap-2">
                {selectedSensors.length > 0 && (
                  <>
                    <button
                      className="btn btn-sm btn-success"
                      onClick={() => this.handleBulkSchakelen(true)}
                      disabled={bulkAction}
                    >
                      <i className="fas fa-toggle-on me-2"></i>
                      {bulkAction ? 'Bezig...' : 'Alle inschakelen'}
                    </button>
                    <button
                      className="btn btn-sm btn-danger"
                      onClick={() => this.handleBulkSchakelen(false)}
                      disabled={bulkAction}
                    >
                      <i className="fas fa-toggle-off me-2"></i>
                      {bulkAction ? 'Bezig...' : 'Alle uitschakelen'}
                    </button>
                    <div className="btn-group">
                      <button
                        className="btn btn-sm btn-warning dropdown-toggle"
                        onClick={() => this.setState({ showAmpereDropdown: !showAmpereDropdown })}
                        disabled={bulkAction}
                      >
                        <i className="fas fa-bolt me-2"></i>
                        {bulkAction ? 'Bezig...' : `Ampere instellen (${selectedAmpere}A)`}
                      </button>
                      {showAmpereDropdown && (
                        <div className="dropdown-menu show position-absolute" style={{ top: '100%', left: 0, zIndex: 1000 }}>
                          {[4, 6, 8, 10, 12, 14, 16, 18, 20, 40, 60, 80, 100].map(ampere => (
                            <button
                              key={ampere}
                              className="dropdown-item"
                              onClick={() => {
                                this.setState({ selectedAmpere: ampere });
                                this.handleBulkAmpere(ampere);
                              }}
                            >
                              {ampere} Ampere
                            </button>
                          ))}
                        </div>
                      )}
                    </div>
                  </>
                )}
              </div>
            </div>
            
            {bulkMessage && (
              <div className={`alert alert-${bulkMessage.type} mt-3 mb-0`}>
                {bulkMessage.text}
              </div>
            )}
          </div>
        </div>

        <ToolkitProvider
          keyField="_id"
          data={dataWithSelections}
          columns={columns}
          search={{
            searchFormatted: false,
          }}
        >
          {(props) => (
            <div>
              <SearchBar placeholder="Zoeken" {...props.searchProps} />
              <hr />
              <BootstrapTable 
                wrapperClasses="table-responsive-md" 
                classes="table-sm"
                pagination={paginationFactory({ 
                  sizePerPage: window.innerWidth <= 768 ? 10 : 20,
                  showTotal: true,
                  sizePerPageList: window.innerWidth <= 768 ? [5, 10, 15] : [10, 20, 50]
                })} 
                {...props.baseProps} 
              />
            </div>
          )}
        </ToolkitProvider>
      </>
    );
  }
}

export default connect(null, { bulkSchakelkwhnmeter, bulkAmpere })(KampeerplaatsLijst);
